module.exports = __webpack_public_path__ + "static/media/Aviso de Privacidad.00240557.pdf";